import React from 'react';
import PropTypes from 'prop-types';

import { useContext } from 'components/Managers/Members/Context';

export default function Statistics({ newMembersCount, terminatedMembersCount, totalMembersCount }) {
  const { state: { finchOptions } } = useContext();

  return (
    <p className="mt-4 fw-light">
      {finchOptions.synchImport && (
        <>
          New Employees:
          {' '}
          <span className="fw-semibold">{newMembersCount}</span>
          <br />

          Terminated Employees:
          {' '}
          <span className="fw-semibold">{terminatedMembersCount}</span>
          <br />
        </>
      )}

      Total Number Of Employees:
      {' '}
      <span className="fw-semibold">{totalMembersCount}</span>
    </p>
  );
}

Statistics.propTypes = {
  newMembersCount: PropTypes.number.isRequired,
  terminatedMembersCount: PropTypes.number.isRequired,
  totalMembersCount: PropTypes.number.isRequired,
};
